var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1F9Fc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 28.5,
    cy: 26.5,
    r: 3.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 29.5,
    cy: 25.5,
    r: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 26,
    cy: 30,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 26.5,
    cy: 29.5,
    r: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M32.469 8.188s1.156 2.375.531 6.844-2.428 7.734-7.384 12.737c-8.411 8.493-14.321 9.461-19.461 4.271-1.883-1.901-2.627-3.883-2.936-5.977S2.991 21.306 3 21c.034-1.234 1.188-4.667 1.188-4.667l28.281-8.145z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4ABBA",
    d: "M10.261 8.358C13.468 5.076 17.79 1.834 21.281 1c3.582-.856 6.319.766 8.484 2.881 1.87 1.827 3.482 4.751 3.141 7.775-.438 3.889-3.512 8.087-7.167 11.827-3.095 3.167-7.228 6.373-10.614 7.267-3.723.982-6.652-.602-8.891-2.79-1.933-1.889-3.565-4.781-3.141-7.929.515-3.813 3.608-8.031 7.168-11.673z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCCD6",
    d: "M11.626 8.375c3.179-3.24 6.801-6.001 10.03-6.531 2.428-.399 4.675.785 6.111 2.193 1.363 1.337 2.642 3.525 2.389 5.807-.368 3.319-3.118 7.05-6.418 10.414-2.682 2.734-6.094 5.501-8.926 6.336-3.049.9-5.481-.297-7.215-1.998-1.618-1.587-2.826-3.994-2.191-6.815.678-3.01 3.345-6.475 6.22-9.406z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 9,
    cy: 10,
    r: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 9.5,
    cy: 9.5,
    r: 2.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 5.5,
    cy: 8.5,
    r: 2.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 12,
    cy: 6,
    r: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 9,
    cy: 3,
    r: 2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 3.5,
    cy: 4.5,
    r: 1.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 18,
    cy: 4,
    r: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 5,
    cy: 15,
    r: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 32.5,
    cy: 25.5,
    r: 2.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fill: "#CCD6DD",
    cx: 33,
    cy: 19,
    r: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 6,
    cy: 8,
    r: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 5.5,
    cy: 14.5,
    r: 1.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 12.5,
    cy: 5.5,
    r: 2.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 9.5,
    cy: 2.5,
    r: 1.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 4,
    cy: 4,
    r: 1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 18.5,
    cy: 3.5,
    r: 1.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 33,
    cy: 25,
    r: 2
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F8FA",
    cx: 33.5,
    cy: 18.5,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F9Fc);
export default __webpack_public_path__ + "static/media/1f9fc.02aabbc460727e7e572169c2420d05bf.svg";
export { ForwardRef as ReactComponent };